import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/** 媒体渠道 Tab 占位数量：汇总 / TikTok / Meta / Google（对齐 AD_CHANNEL_TABS） */
const CHANNEL_TAB_COUNT = 4;

/**
 * 创编管理页面骨架。
 *
 * 这一页比通用列表页多一层「顶部渠道工具栏」（渠道 Tab 胶囊组 + 报表日期范围 + 草稿箱 + 新增广告），
 * 属于投放管理特有结构，因此放在页面模块内，内部复用全局通用的 `ListPageSkeleton`。
 */
export function CreationManagementSkeleton() {
  return (
    <div data-testid="creation-management-skeleton" className="w-full h-full flex flex-col gap-4">
      {/* 顶部渠道工具栏 */}
      <div className="flex items-center justify-between">
        {/*
          真实工具栏的胶囊组是 gap-0，靠「选中态白底」区分 Tab；骨架里 4 个块同色 + gap-0 会连成一片，
          所以这里给 4px 间距，让 4 个 Tab 各自成形（宽度只比真实多 12px）。
        */}
        <div className="flex items-center gap-1 rounded-[8px] bg-[#f5f5f5] dark:bg-[#2a2a2a] p-1.25">
          {/*
            不用默认的 --accent(#f5f5f5)：与胶囊容器底色完全相同，四个 Tab 会直接看不见。
            改用比容器略深的灰（暗色下沿用真实选中态的 #3a3a3a），保证两种主题下都能看出「这里有 4 个 Tab」。
          */}
          {Array.from({ length: CHANNEL_TAB_COUNT }, (_, index) => (
            <Skeleton key={index} className="h-8 w-16 rounded-[4px] bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
          ))}
        </div>

        {/* 日期范围 + 草稿箱 + 新增广告 */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-60" />
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-9 w-28" />
        </div>
      </div>

      {/* 列表卡片（含层级 Tab 行）
          `min-h-0` 必需：否则 flex 子项默认 min-height:auto 不会收缩，
          卡片高度撑开容器后仍会溢出（真实页面靠表格 maxHeight 计算避免）。 */}
      <div className="flex-1 min-h-0 overflow-y-visible">
        {/* 11 列：对齐真实「广告系列」Tab 的表头（勾选 + 广告系列名称/ID + 推广目标 + 状态 + Creative应用 + 广告账户名称/ID + 推广系列预算 + 创建时间 + 操作） */}
        <ListPageSkeleton withHeaderTabs columnCount={11} />
      </div>
    </div>
  );
}

export default CreationManagementSkeleton;
